import { apiGet, apiPost, apiRequest } from "./client";

export const INBOX_STATUSES = [
  "new",
  "reviewing",
  "converted",
  "rejected",
];

export const INBOX_MOTIFS = [
  "formation",
  "gestion",
  "formation_gestion",
  "autre",
];

const qs = (params) => {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const inboxApi = {
  list: (filters) => apiGet(`/api/admin/inbox${qs(filters)}`),
  counts: () => apiGet(`/api/admin/inbox/counts`),
  get: (id) => apiGet(`/api/admin/inbox/${id}`),
  update: (id, patch) =>
    apiRequest(`/api/admin/inbox/${id}`, { method: "PATCH", body: patch }),
  remove: (id) =>
    apiRequest(`/api/admin/inbox/${id}`, { method: "DELETE" }),
  convert: (id, data) => apiPost(`/api/admin/inbox/${id}/convert`, data),
};
